<template>
  <div class="page-wrapper">
    <!-- PC 端 -->
    <div class="pc-version">
      <div class="coupon-table-container" v-loading="loading">
        <div class="search-bar">
          <el-select
            v-model="searchParams.type"
            placeholder="奖品类型"
            clearable
            style="width: 200px"
          >
            <el-option label="B" :value="1"></el-option>
            <el-option label="W" :value="2"></el-option>
          </el-select>

          <el-button type="primary" icon="el-icon-search" @click="getList"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" @click="resetSearch"
            >重置</el-button
          >
          <el-button type="success" icon="el-icon-plus" @click="handleAdd"
            >新增</el-button
          >
        </div>

        <el-table
        height="900"
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
          @row-click="handleRowClick"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column label="类型" prop="type" width="100" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.type == 1 ? "B" : "W" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="盲盒名称" prop="box_name" min-width="180" />
          <el-table-column
            label="盲盒ID"
            prop="box_id"
            width="100"
            align="center"
          />
          <el-table-column
            label="最小数量"
            prop="min_num"
            width="110"
            align="center"
          />
          <el-table-column
            label="最大数量"
            prop="max_num"
            width="110"
            align="center"
          />
          <el-table-column
            label="盲盒价格"
            prop="price"
            width="110"
            align="center"
          />
          <el-table-column label="创建时间" prop="created_at" width="180" />
          <el-table-column label="更新时间" prop="updated_at" width="180" />
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click.native.stop="handleEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                style="color: #f56c6c"
                @click.native.stop="handleDelete(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- PC 新增/编辑弹窗 -->
        <el-dialog
          :title="isEdit ? '编辑奖品设置' : '新增奖品设置'"
          :visible.sync="dialogVisible"
          width="600px"
          @close="resetForm"
          append-to-body
        >
          <el-form
            :model="form"
            :rules="rules"
            ref="formRef"
            label-width="120px"
          >
            <el-form-item label="奖品类型" prop="type">
              <el-select v-model="form.type" placeholder="请选择类型">
                <el-option label="B" :value="1"></el-option>
                <el-option label="W" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择盲盒" prop="box_id">
              <el-select v-model="form.box_id" placeholder="请选择盲盒">
                <el-option
                  v-for="item in blindList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="最小数量" prop="min_num">
              <el-input
                v-model.number="form.min_num"
                placeholder="最小数量"
                type="number"
              ></el-input>
            </el-form-item>
            <el-form-item label="最大数量" prop="max_num">
              <el-input
                v-model.number="form.max_num"
                placeholder="最大数量"
                type="number"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitForm">确认提交</el-button>
          </div>
        </el-dialog>

        <!-- PC 详情弹窗 -->
        <el-dialog
          title="详情"
          :visible.sync="detailVisible"
          width="700px"
          append-to-body
        >
          <el-form :model="detailForm" label-width="120px" size="small">
            <el-form-item label="ID"
              ><span>{{ detailForm.id }}</span></el-form-item
            >
            <el-form-item label="类型">
              <span>{{ detailForm.type == 1 ? "B" : "W" }}</span>
            </el-form-item>
            <el-form-item label="盲盒名称"
              ><span>{{ detailForm.box_name }}</span></el-form-item
            >
            <el-form-item label="盲盒ID"
              ><span>{{ detailForm.box_id }}</span></el-form-item
            >
            <el-form-item label="最小数量"
              ><span>{{ detailForm.min_num }}</span></el-form-item
            >
            <el-form-item label="最大数量"
              ><span>{{ detailForm.max_num }}</span></el-form-item
            >
            <el-form-item label="盲盒价格"
              ><span>{{ detailForm.price }}</span></el-form-item
            >
            <el-form-item label="创建时间"
              ><span>{{ detailForm.created_at }}</span></el-form-item
            >
            <el-form-item label="更新时间"
              ><span>{{ detailForm.updated_at }}</span></el-form-item
            >
          </el-form>
          <div slot="footer">
            <el-button @click="detailVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- 移动端 -->
    <div class="mobile-version">
      <div class="mobile-coupon-container" v-loading="loading">
        <div class="mobile-search-group">
          <el-select
            v-model="searchParams.type"
            placeholder="奖品类型"
            clearable
            size="medium"
            style="flex: 1"
          >
            <el-option label="B" :value="1"></el-option>
            <el-option label="W" :value="2"></el-option>
          </el-select>

          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="primary"
              plain
              round
              @click="getList"
              style="flex: 1"
              >搜索</el-button
            >
            <el-button plain round @click="resetSearch" style="flex: 1"
              >重置</el-button
            >
            <el-button
              type="success"
              plain
              round
              @click="openMobileAdd"
              style="flex: 1"
              >添加</el-button
            >
          </div>
        </div>

        <!-- 移动端卡片列表 -->
        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="openMobileDetail(item)"
          >
            <div class="card-header">
              <div class="info">
                <div class="title">{{ item.box_name }}</div>
                <div class="meta">
                  ID:{{ item.id }} | 盲盒ID:{{ item.box_id }}
                </div>
              </div>
              <div
                class="type-tag"
                :class="item.type == 1 ? 'type-b' : 'type-w'"
              >
                {{ item.type == 1 ? "B" : "W" }}
              </div>
            </div>
            <div class="card-body">
              <div>数量：{{ item.min_num }} ~ {{ item.max_num }}</div>
              <div>价格：{{ item.price }}</div>
              <div>创建：{{ item.created_at }}</div>
            </div>
            <div class="card-footer">
              <el-button
                size="mini"
                type="primary"
                round
                @click.stop="openMobileEdit(item)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                round
                @click.stop="handleDelete(item)"
                >删除</el-button
              >
            </div>
          </div>
        </div>

        <!-- 移动端分页【新增】 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          :total="pageInfo.total"
          layout="total, prev, pager, next, jumper"
          pager-count="2"
          small
        />

        <!-- 移动端详情 -->
        <el-dialog
          title="详情"
          :visible.sync="mobileDetailVisible"
          width="90%"
          append-to-body
          class="mobile-dialog"
        >
          <el-form :model="mobileDetailRow" label-width="100px" size="small">
            <el-form-item label="ID"
              ><span>{{ mobileDetailRow.id }}</span></el-form-item
            >
            <el-form-item label="类型">
              <span>{{ mobileDetailRow.type == 1 ? "B" : "W" }}</span>
            </el-form-item>
            <el-form-item label="盲盒名称"
              ><span>{{ mobileDetailRow.box_name }}</span></el-form-item
            >
            <el-form-item label="盲盒ID"
              ><span>{{ mobileDetailRow.box_id }}</span></el-form-item
            >
            <el-form-item label="最小数量"
              ><span>{{ mobileDetailRow.min_num }}</span></el-form-item
            >
            <el-form-item label="最大数量"
              ><span>{{ mobileDetailRow.max_num }}</span></el-form-item
            >
            <el-form-item label="价格"
              ><span>{{ mobileDetailRow.price }}</span></el-form-item
            >
            <el-form-item label="创建时间"
              ><span>{{ mobileDetailRow.created_at }}</span></el-form-item
            >
            <el-form-item label="更新时间"
              ><span>{{ mobileDetailRow.updated_at }}</span></el-form-item
            >
          </el-form>
          <div slot="footer">
            <el-button @click="mobileDetailVisible = false">关闭</el-button>
          </div>
        </el-dialog>

        <!-- 移动端添加 -->
        <el-dialog
          title="添加"
          :visible.sync="mobileAddVisible"
          width="95%"
          top="10vh"
          append-to-body
          class="mobile-dialog"
        >
          <el-form
            :model="mobileAddForm"
            :rules="rules"
            ref="mobileAddRef"
            label-width="100px"
            size="small"
          >
            <el-form-item label="类型" prop="type">
              <el-select v-model="mobileAddForm.type" size="medium">
                <el-option label="B" :value="1"></el-option>
                <el-option label="W" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="盲盒" prop="box_id">
              <el-select v-model="mobileAddForm.box_id" size="medium">
                <el-option
                  v-for="item in blindList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="最小数量" prop="min_num">
              <el-input
                v-model.number="mobileAddForm.min_num"
                size="medium"
                type="number"
              />
            </el-form-item>
            <el-form-item label="最大数量" prop="max_num">
              <el-input
                v-model.number="mobileAddForm.max_num"
                size="medium"
                type="number"
              />
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            style="display: flex; justify-content: flex-end; gap: 10px"
          >
            <el-button size="medium" @click="mobileAddVisible = false"
              >取消</el-button
            >
            <el-button type="primary" size="medium" @click="submitMobileAdd"
              >保存</el-button
            >
          </div>
        </el-dialog>

        <!-- 移动端编辑 -->
        <el-dialog
          title="编辑"
          :visible.sync="mobileEditVisible"
          width="95%"
          top="10vh"
          append-to-body
          class="mobile-dialog"
        >
          <el-form
            :model="mobileEditForm"
            :rules="editRules"
            ref="mobileEditRef"
            label-width="100px"
            size="small"
          >
            <el-form-item label="类型">
              <span>{{ mobileEditForm.type == 1 ? "B" : "W" }}</span>
            </el-form-item>
            <el-form-item label="盲盒">
              <span>{{ mobileEditForm.box_name }}</span>
            </el-form-item>
            <el-form-item label="最小数量" prop="min_num">
              <el-input
                v-model.number="mobileEditForm.min_num"
                size="medium"
                type="number"
              />
            </el-form-item>
            <el-form-item label="最大数量" prop="max_num">
              <el-input
                v-model.number="mobileEditForm.max_num"
                size="medium"
                type="number"
              />
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            style="display: flex; justify-content: flex-end; gap: 10px"
          >
            <el-button size="medium" @click="mobileEditVisible = false"
              >取消</el-button
            >
            <el-button type="primary" size="medium" @click="submitMobileEdit"
              >保存</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "BlindPrizeSet",
  data() {
    return {
      loading: false,
      tableData: [],
      blindList: [],
      pageInfo: { total: 0 },
      searchParams: { page: 1, page_size: 10, type: "" },

      dialogVisible: false,
      isEdit: false,
      form: {
        id: "",
        type: "",
        box_id: "",
        min_num: "",
        max_num: "",
      },
      rules: {
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        box_id: [{ required: true, message: "请选择盲盒", trigger: "change" }],
        min_num: [
          { required: true, message: "请输入最小数量", trigger: "blur" },
        ],
        max_num: [
          { required: true, message: "请输入最大数量", trigger: "blur" },
        ],
      },
      editRules: {
        min_num: [
          { required: true, message: "请输入最小数量", trigger: "blur" },
        ],
        max_num: [
          { required: true, message: "请输入最大数量", trigger: "blur" },
        ],
      },

      detailVisible: false,
      detailForm: {},

      // 移动端
      mobileDetailVisible: false,
      mobileDetailRow: {},
      mobileAddVisible: false,
      mobileAddForm: {},
      mobileEditVisible: false,
      mobileEditForm: {},
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        const res = await api.blindPrizeSet.index({
          params: this.searchParams,
        });
        if (res.data.code == 1000) {
          this.tableData = res.data.data.data;
          this.blindList = res.data.data.blind_data || [];
          this.pageInfo.total = res.data.data.total;
        }
      } finally {
        this.loading = false;
      }
    },

    // PC 新增
    handleAdd() {
      this.isEdit = false;
      this.resetForm();
      this.dialogVisible = true;
    },

    // PC 编辑
    handleEdit(row) {
      this.isEdit = true;
      this.form = { ...row };
      this.dialogVisible = true;
    },

    // 提交
    async submitForm() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        try {
          if (this.isEdit) {
            await api.blindPrizeSet.edit({
              set_id: this.form.id,
              min_num: this.form.min_num,
              max_num: this.form.max_num,
            });
          } else {
            await api.blindPrizeSet.add({
              type: this.form.type,
              box_id: this.form.box_id,
              min_num: this.form.min_num,
              max_num: this.form.max_num,
            });
          }
          this.getList();
          this.dialogVisible = false;
        } finally {
          this.loading = false;
        }
      });
    },

    // 删除
    handleDelete(row) {
      this.$confirm("确定删除该配置？", "提示", { type: "warning" }).then(
        async () => {
          this.loading = true;
          try {
            await api.blindPrizeSet.del({ set_id: row.id });
            this.getList();
          } finally {
            this.loading = false;
          }
        }
      );
    },

    resetForm() {
      this.form = {
        id: "",
        type: "",
        box_id: "",
        min_num: "",
        max_num: "",
      };
    },

    resetSearch() {
      this.searchParams = { page: 1, page_size: 10, type: "" };
      this.getList();
    },

    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },

    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },

    handleRowClick(row) {
      this.detailForm = row;
      this.detailVisible = true;
    },

    // 移动端
    openMobileAdd() {
      this.mobileAddForm = {
        type: "",
        box_id: "",
        min_num: "",
        max_num: "",
      };
      this.mobileAddVisible = true;
    },

    async submitMobileAdd() {
      this.$refs.mobileAddRef.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        try {
          await api.blindPrizeSet.add(this.mobileAddForm);
          this.mobileAddVisible = false;
          this.getList();
        } finally {
          this.loading = false;
        }
      });
    },

    openMobileEdit(row) {
      this.mobileEditForm = JSON.parse(JSON.stringify(row));
      this.mobileEditVisible = true;
    },

    async submitMobileEdit() {
      this.$refs.mobileEditRef.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        try {
          await api.blindPrizeSet.edit({
            set_id: this.mobileEditForm.id,
            min_num: this.mobileEditForm.min_num,
            max_num: this.mobileEditForm.max_num,
          });
          this.mobileEditVisible = false;
          this.getList();
        } finally {
          this.loading = false;
        }
      });
    },

    openMobileDetail(row) {
      this.mobileDetailRow = row;
      this.mobileDetailVisible = true;
    },
  },
};
</script>

<style scoped>
.coupon-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
}
.dialog-footer {
  text-align: right;
}

/* 移动端 */
.mobile-coupon-container {
  padding: 12px;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 16px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.type-tag {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: bold;
}
.type-b {
  background: #e6f7ff;
  color: #1890ff;
}
.type-w {
  background: #fff7e6;
  color: #fa8c16;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}
.card-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
/* 移动端分页样式【新增】 */
.mobile-pagination {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/system/blindPrizeSet.vue